const normalizeText = (value: any) => String(value || "").trim();

type BuildBehaviorPrnSyncPayloadArgs = {
  backendAPIStore: any;
  residentId: string;
  behaviorPayload: Record<string, any>;
};

export const buildBehaviorPrnMedicationOptions = (items: any[]) =>
  (Array.isArray(items) ? items : [])
    .filter((item: any) => item?.active !== false && item?.deletedAt == null && item?.prn === true)
    .map((item: any) => {
      const medicationName = normalizeText(item?.medicationName) || "PRN medication";
      const dosage = normalizeText(item?.dosage);
      const route = normalizeText(item?.route);
      const detailParts = [dosage, route].filter(Boolean);
      return {
        label: detailParts.length ? `${medicationName} (${detailParts.join(" / ")})` : medicationName,
        value: normalizeText(item?.medicationId),
        medicationName,
      };
    })
    .filter((item: any) => item.value);

export const buildBehaviorPrnSyncPayload = async (args: BuildBehaviorPrnSyncPayloadArgs) => {
  const { behaviorPayload } = args;

  if (behaviorPayload?.prnUsed !== true) {
    return {
      ...behaviorPayload,
      prnUsed: false,
      prnEntryMode: "",
      linkedPrnEntryId: "",
      linkedPrnMedicationId: "",
      linkedPrnMedicationName: "",
      prnMedicationName: "",
      prnReasonCode: "",
      prnReasonLabel: "",
      prnDetails: "",
    };
  }

  const prnEntryMode = normalizeText(behaviorPayload?.prnEntryMode).toLowerCase() === "emar" ? "emar" : "manual";
  if (prnEntryMode !== "emar") {
    return {
      ...behaviorPayload,
      prnUsed: true,
      prnEntryMode: "manual",
      linkedPrnEntryId: "",
      linkedPrnMedicationId: "",
      linkedPrnMedicationName: "",
      prnMedicationName: normalizeText(behaviorPayload?.prnMedicationName),
      prnReasonCode: "",
      prnReasonLabel: "",
      prnDetails: normalizeText(behaviorPayload?.prnDetails),
    };
  }

  return {
    ...behaviorPayload,
    prnUsed: true,
    prnEntryMode: "emar",
    linkedPrnEntryId: normalizeText(behaviorPayload?.linkedPrnEntryId),
    linkedPrnMedicationId: normalizeText(behaviorPayload?.linkedPrnMedicationId),
    linkedPrnMedicationName: normalizeText(behaviorPayload?.linkedPrnMedicationName),
    prnMedicationName: normalizeText(behaviorPayload?.linkedPrnMedicationName || behaviorPayload?.prnMedicationName),
    prnReasonCode: "",
    prnReasonLabel: "",
    prnDetails: normalizeText(behaviorPayload?.prnDetails),
  };
};
